<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();
const handleSetSurface = surface => {
  store.commit("artwork/setSurface", surface);
  store.commit("artwork/clearArtworkSize");
  store.commit("checkout/setCurrentPlacementAction", "position_change");
};
const currentSurface = computed(() => store.getters["artwork/surfaceLabel"]);
</script>

<template>
  <div class="artwork-surface-position">
    <button
      class="artwork-surface-position__button"
      :disabled="currentSurface === 'front'"
      @click="handleSetSurface('front')"
    >
      Front center
    </button>
    <button
      class="artwork-surface-position__button"
      :disabled="currentSurface === 'back'"
      @click="handleSetSurface('back')"
    >
      Back center
    </button>
    <button
      class="artwork-surface-position__button"
      :disabled="currentSurface === 'frontLeftChest'"
      @click="handleSetSurface('frontLeftChest')"
    >
      Left chest
    </button>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/pod/settings";
@import "frontend/init/jiffy/mixin";
@import "frontend/init/jiffy/button/mixin";

.artwork-surface-position {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 8px;

  &__button {
    @include clear-button;

    height: 34px;
    border-radius: 6px;
    border: 2px solid $pod-gray-modern-200;
    color: $pod-gray-modern-900;
    font-size: 13px;
    font-weight: 500;

    &[disabled] {
      cursor: not-allowed;
      background: $pod-gray-modern-900;
      color: $white;
      border-color: transparent;
    }
  }
}
</style>
